/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBookRefresh = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M15 14a3 3 0 1 0 0 6v2a5 5 0 1 1 5-5v.586l1.293-1.293 1.414 1.414L19 21.414l-3.707-3.707 1.414-1.414L18 17.586V17a3 3 0 0 0-3-3z"
        fill="currentcolor"
      />
      <path
        d="M3 2a1 1 0 0 0-1 1v14.999a1 1 0 0 0 1 1h5.31A6.57 6.57 0 0 1 8 17l-4-.001V4h5.001A2 2 0 0 1 11 5.999v5.4a7.67 7.67 0 0 1 2-1v-4.4A2 2 0 0 1 14.999 4H20v7.4a7.217 7.217 0 0 1 2 2.105V3a1 1 0 0 0-1-1h-6.001A3.99 3.99 0 0 0 12 3.354 3.99 3.99 0 0 0 9.001 2H3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBookRefresh as BookRefresh };
